export default __webpack_public_path__ + "static/artifakt-legend-bold-d540b73e025c92bd61677bc3944fb156.svg";